"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var StyledHeading_1 = require("./StyledHeading");
var HeadingInner = function (props) {
    var color = props.color, // munged to avoid styled-components putting it in the DOM
    level = props.level, rest = tslib_1.__rest(props, ["color", "level"]);
    var tag = "h" + level;
    // enforce level to be a number
    return React.createElement(StyledHeading_1.StyledHeading, tslib_1.__assign({ as: tag, colorProp: color, level: +(level || 1) }, rest));
};
HeadingInner.defaultProps = {
    level: 1,
    responsive: true,
    color: 'text'
};
/** @component */
exports.Heading = recompose_1.compose(styled_components_1.withTheme)(HeadingInner);
//# sourceMappingURL=Heading.js.map